__turbopack_context__.v({
  "gridRow": "AllArticles-module__C9BXtW__gridRow",
  "pagination": "AllArticles-module__C9BXtW__pagination",
  "title": "AllArticles-module__C9BXtW__title",
});
